<script>
export default {
	methods: {
		isCategoryDisabled(category) {
			return this.disabled || category.isLockedForCurrentStudent;
		},
		isCategoryEnabled(category) {
			return !this.disabled && !category.isLockedForCurrentStudent;
			//  && !category.isCompletedForCurrentStudent
		},
		isCategoryBudgeted(category) {
			if (this.$store.getters.isInBudgetingPhase) {
				return category.isBudgeted || category.allocatedBudget > 0;
			}

			return false;
		}
	}
};
</script>
